import { render } from "./RulesByAmount.vue?vue&type=template&id=930067e2"
import script from "./RulesByAmount.vue?vue&type=script&lang=js"
export * from "./RulesByAmount.vue?vue&type=script&lang=js"

import "./RulesByAmount.vue?vue&type=style&index=0&id=930067e2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__